<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="60%"
    top="5vh"
  >
    <el-form
      :ref="formRef"
      :rules="rules"
      :model="KSmallform"
      label-width="200px"
    >
    <el-form-item prop="brandCode" :label="$t('title.brand')">
        <el-select style="width: 200px" v-model="KSmallform.brandCode" :placeholder="$t('desc.select')">
          <el-option
            :label="brandInfo.brandName"
            :value="brandInfo.brandCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="kTypeId" :label="$t('title.productLine')">
        <el-select
          @change="selMTChange"
          v-model="KSmallform.kTypeId"
          :placeholder="$t('desc.select')"
        >
          <el-option
            v-for="item in MTypeTable"
            :key="item.id"
            :label="item.kType"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="kProductId" :label="$t('title.productCategories')">
        <el-select v-model="KSmallform.kProductId" :placeholder="$t('desc.select')">
          <el-option
            v-for="item in MProductTable"
            :key="item.id"
            :label="item.modelDesc"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="kSmall" :label="$t('title.smallClassProduct')">
        <el-input v-model="KSmallform.kSmall" style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item v-if="isShowUpload"  prop="uploadImg" :label="$t('title.smallClassProduct')">
        <el-upload
          class="upload-demo"
          action=""
          ref="imgUpload"
          :auto-upload="false"
          :on-change="imgOnChange"
          :before-upload="imgBeforeUpload"
          :before-remove="imgBeforeRemove"
          :file-list="fileList"
          list-type="picture"
          :show-file-list="true"
        >
          <el-button size="small" type="primary">{{$t('button.upload')}}</el-button>
          <div slot="tip" class="el-upload__tip">
            {{$t("tips.uploadInfo2")}}
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          v-if="subButtonAuth"
          type="success"
          @click="onSubBtn(formRef)"
          >{{$t('button.confirm')}}</el-button
        >
        <el-button @click="doClose">{{$t('button.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {getBrandInfos} from "../../../api/api"
export default {
  name: "index",
  props: {
    loading:false,
    subButtonAuth: true,
    title: "",
    formRef: "",
    dialogAddClient: false,
    KSmallform: {
      kTypeId: "",
      kType: "",
      kProductId: "",
      kProduct: "",
      kSmallId: "",
      kSmall: "",
      fileList: {
        type: Array,
        default: function () {
          return [];
        },
      },
    },
    MTypeTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
    MProductTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
    brandInfo:{},
  },
  data() {
    var validateLicense = (rule, value, callback) => {
      if (!(this.imgSizeIsSatisfy.length === 0)) {
        callback(new Error(this.$t('tips.uploadInfo')));
      } else {
        callback();
      }
    };
    return {
      isShowUpload:false,
      rules: {
        brandCode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        kTypeId: [
          { required: true, message: this.$t("tips.needed"), trigger: ["blur", "change"] },
        ],
        kProductId: [
          { required: true, message: this.$t("tips.needed"), trigger: ["blur", "change"] },
        ],
        kSmall: [{ required: true, message: this.$t("tips.needed"), trigger: "blur" }],
        uploadImg: [{ validator: validateLicense }],
      },
      uploadImg: [],
      imgSizeIsSatisfy: [],
      fileList: [],
      
    };
  },
  methods: {
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          // var formData = this.saveDealEvent();
          // this.$emit("onSubBtn", formData);
          this.$emit("onSubBtn", true);
          // this.$nextTick(() => {
          //   this.uploadImg = [];
          //   this.$refs[value].resetFields();
          // });
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.formRef].resetFields();
    },
    selMTChange(value) {
      this.$emit("selMTChange", value);

    },
    handlePreview(file) {
      //console.log(file);
    },
    imgBeforeUpload(file) {
      this.uploadImg.push(file);
      return false;
    },
    saveDealEvent() {
      const formData = new FormData();
      Object.keys(this.KSmallform).forEach((key) => {
        formData.append(key, this.KSmallform[key]);
      });
      formData.append("eventId", this.evtId);
      this.$refs.imgUpload.submit();
      for (let i = 0; i < this.uploadImg.length; i++) {
        formData.append("imgFIle", this.uploadImg[i]);
      }
      return formData;
    },
    imgOnChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
        this.imgBeforeRemove(fileList[0]); // 这一步，是 展示最后一次选择的csv文件
      }
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.imgSizeIsSatisfy.push(file.name);
        this.$refs[this.formRef].validateField("uploadImg");
      }
    },
    imgBeforeRemove(file) {
      if (!(this.imgSizeIsSatisfy.indexOf(file.name) === -1)) {
        let temp = this.imgSizeIsSatisfy.indexOf(file.name);
        this.imgSizeIsSatisfy.splice(temp, 1);
        this.$refs[this.formRef].validateField("uploadImg");
      }
      // return false;
    },
  },
};
</script>

<style scoped>
</style>
